import styled, { keyframes, css } from "styled-components";

const pulseRing = keyframes`
  0% {
    transform: scale(0.33);
  }

  80%, 100% {
    opacity: 0;
  }
`;

const fadeIn = keyframes`
  0% {
    transform: scale(0.5);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const slideUp = keyframes`
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
`;

const slideDown = keyframes`
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100%);
  }
`;

const fadeInAnimation = keyframes`
  0% {
    transform: scale(0);
    opacity: 0;
    top: 295px;
    left: 204px;
  }

  100% {
    transform: scale(1);
    opacity: 1;
    top: 295px;
    left: 204px;
  }
`;

const fadeInAnim = keyframes`
  0% {
    transform: scale(0);
    opacity: 0;
    top: 205px;
    left: 204px;
  }

  100% {
    transform: scale(1);
    opacity: 1;
    top: 205px;
    left: 204px;
  }
`;

export const BrandLpContainer = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const BrandLpBgTop = styled.div`
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  height: calc(100vh - 285px);
`;

export const TerminalMarker = styled.div`
  position: absolute;
  right: 25%;
  top: 27.5%;
  font-size: 14px;

  & > .tooltip-text-container > .tooltip-text {
    bottom: calc(100% + 32px);
    background-color: #fff;
    color: #000;
    font-family: "Lato";
    font-weight: 400;
    font-size: 12px;

    &:after {
      border-color: #fff transparent transparent transparent;
    }
  }
`;

export const PulsatingCircle = styled.div`
  position: absolute;
  transform: translateX(-50%) translateY(-50%);
  width: 30px;
  height: 30px;

  &:before {
    content: "";
    position: relative;
    display: block;
    width: 300%;
    height: 300%;
    box-sizing: border-box;
    margin-left: -100%;
    margin-top: -100%;
    border-radius: 50%;
    background-color: #008cff;
    animation: ${pulseRing} 1.25s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
  }

  &:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    width: 100%;
    height: 100%;
    background-color: transparent;
    border-radius: 100px;
  }
`;

export const InnerCircle = styled.span`
  position: absolute;
  border-radius: 50%;
  left: 50%;
  top: 50%;
  width: 18px;
  height: 18px;
  border: 2px solid #000;
  transform: translate(-50%, -50%);
`;

export const InnerPlus = styled.span`
  position: absolute;
  box-sizing: border-box;
  display: block;
  background: #008cff;
  border-radius: 50%;
  text-align: center;
  width: 14px;
  height: 14px;
  left: 50%;
  transform: translate(-50%, 0);
  border: 2px solid #fff;
`;

export const TerminalCabsContainer = styled.div`
  position: absolute;
  top: 195px;
  left: 104px;
  font-family: "Lato";
  font-size: 12px;
  animation: ${fadeIn} 0.6s ease-in-out forwards;

  &.newCabPosition {
    animation: ${fadeInAnimation} 0.6s ease-in-out forwards;
    animation-delay: 0s;
  }

  @media only screen and (max-height: 700px) {
    top: 135px;
    left: 104px;

    &.newCabPosition {
      animation: ${fadeInAnim} 0.6s ease-in-out forwards;
      animation-delay: 0s;
    }
  }

  & > .cab-images {
    height: 60px;
    width: 60px;
    position: absolute;
    top: 2px;
    left: -10px;
  }
`;

export const TerminalCarImg = styled.img`
  position: absolute;
  height: 60px;

  &.cab1 {
    left: -29px;
    transform: rotate(60deg);
  }

  &.cab2 {
    left: -6px;
    top: 10px;
    transform: rotate(26deg);
  }

  &.cab3 {
    left: 18px;
    transform: rotate(-10deg);
  }
`;

export const BrandLpHeader = styled.div`
  padding: 16px;
  align-items: center;
  display: flex;
`;

export const MmtLogo = styled.img`
  margin-right: 5px;
  height: 24px;
  width: 24px;
`;

export const BrandMMTHeaderTitle = styled.span`
  font-size: 12px;
  font-weight: 900;
  font-family: Lato;
`;

export const BrandLpBgBottom = styled.div`
  padding: 16px;
  background: linear-gradient(to bottom, transparent, #fff);
`;

export const GetCabTitle = styled.p`
  font-family: "Lato";
  font-size: 22px;
  font-weight: 900;
  line-height: 26px;
  margin-bottom: 4px;
`;

export const GetBrandSubTitle = styled.p`
  font-family: "Lato";
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  margin-bottom: 8px;
  color: #4a4a4a;
`;

export const PartnerCabLogos = styled.div`
  display: flex;
  gap: 14px;
`;

export const SchedulingSectionContainer = styled.div`
  padding: 0px 16px;
`;

export const PickLabel = styled.p`
  font-family: "Lato";
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 4px;
  color: #4a4a4a;
`;

export const PickupEditContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export const PickUpLocation = styled.p`
  font-family: "Lato";
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  margin-bottom: 16px;
  color: #4a4a4a;
`;

export const EditIcon = styled.img`
  width: 18px;
  height: 18px;
  margin-left: 4px;
`;

export const DtLabel = styled.p`
  font-family: "Lato";
  font-size: 14px;
  margin-bottom: 4px;
  font-weight: 400;
`;

export const FlightTxtMsgContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 9px;

  > img {
    width: 12.41px;
    height: 11.33px;
    margin-right: 4px;
  }

  > p {
    font-family: "Lato";
    font-size: 12px;
    font-weight: 400;
    color: #4a4a4a;

    > span {
      font-family: "Lato";
      font-size: 14px;
      font-weight: 700;
      color: #4a4a4a;
    }
  }
`;

export const DateNTime = styled.p`
  font-family: "Lato";
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;

  > .dot-seperator {
    color: #ccc;
    margin-bottom: 10px;
    font-size: 22px;
    padding: 0px 4px;
  }
`;

export const RideTime = styled.span`
  font-family: "Lato";
  font-weight: 700;
  font-size: 16px;
`;

export const Seperator = styled.span`
  color: #ccc;
  margin-bottom: 3px;
  padding: 0px 4px;
`;

export const BottomFixedSection = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
`;

export const SchedulingSection = styled.div`
  background-color: #fff;
`;

export const DateTimeWrapper = styled.div`
  margin-bottom: 15px;
`;

export const DateTimeSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const EditTimeContainer = styled.div`
  font-family: "Lato";
  padding: 7px 12px;
  border-radius: 8px;
  border: 1px solid #008cff;
  display: flex;
  height: fit-content;
  color: #008cff;
  font-weight: 700;
  font-size: 14px;
  align-items: center;
  justify-content: center;

  & > img {
    height: 6px;
    width: 6px;
    margin-left: 4px;
    margin-top: 2px;
  }
`;

export const BottomBrandBtn = styled.div`
  padding: 0px 16px 16px 16px;

  .primaryCustBtn {
    width: 100%;
    border-radius: 8px;
    padding: 12px 20px 12px 20px;
    font-weight: 700;
    font-size: 16px;
    font-family: "Lato";
    background-image: linear-gradient(92deg, #53b2fe 0%, #065af3 100%);
  }
`;

export const WidgetPopUp = styled.div`
  border-radius: 4;
  justify-content: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  background-color: #ccc;
  min-width: 316;
  z-index: 100;
`;

export const SmallCabLogos = styled.img`
  width: 40px;
  height: 38px;
  object-fit: contain;
`;

export const InputLocationCont = styled.div(
  (props) => `
  height: 50px;
  border: 1px solid ${props?.showDisabled ? "#D8D8D8" : "#008CFF"};
  background: #EAF5FF;
  font-family: 'Lato';
  font-weight: 500;
  padding: 6px 12px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  margin-bottom: 15px;

  img {
    height: 24px;
    width: 24px;
  }

  .titleSubtitleCont {
    padding-left: 12px;
  }

  .title {
    font-weight: 700 !important;
    font-size: 12px !important;
    color: ${props?.showDisabled ? "#757575" : "#008CFF"};
  }

  .subtitle {
    font-weight: 700;
    font-size: 16px;
    width: calc(100vw - 92px);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    color: ${props?.showDisabled ? "#4A4A4A" : "#141823"};
  }
`
);

export const BottomSheetBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  opacity: 0;
  transition: opacity 0.3s ease-out;
  z-index: 999;

  ${(props) =>
    props.isOpen &&
    css`
      opacity: 1;
    `}
`;

export const BottomSheet = styled.div`
  width: 100%;
  max-height: 100%;
  background: white !important;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  animation: ${(props) => (props.isOpen ? slideUp : slideDown)} 0.3s forwards;
  font-family: "Lato" !important;
  z-index: 1000;
`;
